import api from './client';
import type { FormPreviewPayload } from '../../components/pages/FormJsonEditorPage/formPreviewPayload';

/**
 * Form-editor PDF preview: render the current (possibly unsaved) form config to a
 * REAL PDF through the backend's headless-Chrome pipeline, so the editor can embed
 * the actual paginated output instead of an on-screen approximation.
 */
export const formPreviewService = {
  /** Render the config to a PDF and return it as a Blob for embedding. Admin-only. */
  render: async (payload: FormPreviewPayload): Promise<Blob> => {
    const response = await api.post('/form-preview/render', payload, {
      responseType: 'blob',
    });
    return response.data;
  },

  /** Fetch a stashed payload by id — called by the headless /print/form-preview route. */
  getPayload: async (previewId: string): Promise<FormPreviewPayload> => {
    const response = await api.get(`/form-preview/${previewId}`);
    return response.data;
  },
};
